import { render, staticRenderFns } from "./bag-model-quantity.vue?vue&type=template&id=6cbb674c&scoped=true&lang=pug&"
import script from "./bag-model-quantity.vue?vue&type=script&lang=ts&"
export * from "./bag-model-quantity.vue?vue&type=script&lang=ts&"
import style0 from "./bag-model-quantity.vue?vue&type=style&index=0&id=6cbb674c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb674c",
  null
  
)

export default component.exports